import styled from '@emotion/styled';
import { InputLabel } from '@mui/material';

export const StyledInputLabel = styled(InputLabel)`
  color: var(--color-deep-ocean-blue);
  font-weight: 500;
  margin-bottom: 2px;
`;

/** Native <label> with same look; use when the label must be a plain label for W3C required-field checkers (e.g. AccessibleSelect). */
export const StyledLabel = styled.label`
  display: block;
  color: var(--color-deep-ocean-blue);
  font-weight: 500;
  margin-bottom: 2px;
`;

/** Same look as StyledInputLabel but a span, for section headings that don't label a single control. */
export const StyledSectionHeading = styled.span`
  display: block;
  color: var(--color-deep-ocean-blue);
  font-weight: 500;
  margin-bottom: 2px;
`;
